import React from "react";
import customTextStyle from "assets/jss/hitract-styles/components/customTextStyle.js";
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from "prop-types";
import Linkify from 'react-linkify';
import { validateURL } from "utils/helpers.js";
import TruncateMarkup from 'react-truncate-markup';
import { useTranslation } from 'react-i18next';

const processString = require('react-process-string');

const useStyles = makeStyles(customTextStyle);

const CustomText = (props) => {
    const { children, className, style, mentions, urls, truncateLines, showReadMore=true } = props
    const classes = useStyles();
    const { t } = useTranslation();

    const [toggleTruncate, setToggleTruncate] = React.useState(false)

    const readMoreEllipsis = (
        <span>
          ...{' '}
          {showReadMore &&
          <span onClick={() => setToggleTruncate(true)} className={classes.link}>
            {t('general.prompts.readMore')}
          </span>
          }
        </span>
    );  

    const readLessEllipsis = (
        <span>
          {' '}
            <span onClick={() => setToggleTruncate(false)} className={classes.link}>
            {t('general.prompts.readLess')}
            </span>
        </span>
    ); 

    let config = [
        urls &&
        {
        // CONFIG FOR URLS
        regex: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
        // eslint-disable-next-line react/display-name
        fn: (key, result) => <span key={key}>
                                 <a rel="noreferrer" target="_blank" href={`${validateURL(result[0]) ? result[0] : `http://${result[0]}`}`}>{result[0]}</a>
                             </span>
        }, 
        mentions &&
        {
        // CONFIG FOR MENTIONS
        regex: /@\[([a-zA-ZäöåÄÖÅàèéìíîòóùúÀÈÉÌÍÎÒÓÙÚ0-9\s]+)\]\((company|user):([0-9]+)\)/g,
        // eslint-disable-next-line react/display-name
        fn: (key, result) => <span key={key}>
                                 <a rel="noreferrer" target="_blank" href={`/${result[2] === 'user' ? 'student' : 'foretag'}/${result[3]}`}>@{result[1]}</a>
                             </span>
        }
    ];

    const stringToProcess = children?.toString()
    let processedString = null

    if(urls || mentions) {
        processedString = processString(config)(stringToProcess);
    }

    const renderText = () => {
        if(urls || mentions) {
            if(parseInt(truncateLines) > 0) {
                return (
                    <Linkify>
                        {!toggleTruncate ?
                            <TruncateMarkup lines={parseInt(truncateLines)} ellipsis={readMoreEllipsis}>
                                <p className={className}>
                                    {processedString}
                                </p>
                            </TruncateMarkup>
                            :
                            <p className={className} style={style}>
                                {processedString}
                                {readLessEllipsis}
                            </p>
                        }
                    </Linkify>
                ); 
            }
            else {
                return (
                    <Linkify>
                        <p className={className} style={style}>
                            {processedString}
                        </p>
                    </Linkify>
                );
            }           
        }
        if(parseInt(truncateLines) > 0) {
            return (
            <>
                {!toggleTruncate ?
                    <TruncateMarkup lines={parseInt(truncateLines)} ellipsis={readMoreEllipsis}>
                        <p className={className} style={style}>
                            {children}
                        </p>
                    </TruncateMarkup>
                    :
                    <p className={className} style={style}>
                        {children}
                        {readLessEllipsis}
                    </p>
                }
            </>
            )
        }
        else {
            return (
                <p className={className} style={style}>
                    {children}
                </p>
            );
        }
    };

    return (
        renderText()
    )
};

export default CustomText;

CustomText.defaultProps = {
    mentions: false,
    urls: false,
    truncateLines: 0
}

CustomText.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
    className: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string,
        PropTypes.arrayOf(
          PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.bool,
            PropTypes.object,
            PropTypes.string
          ])
        )
    ]),
    mentions: PropTypes.bool,
    urls: PropTypes.bool,
    truncateLines: PropTypes.number
  };
